import React, { useId } from "react";
import { Switch as AntdSwitch } from "antd";
import "./style.scss";

interface SwitchCompProps extends Pick<any, "checked" | "onChange" | "size"> {
  label?: string;
  className?: string;
  labelClassName?: string;
  inputClassName?: string;
  disabled?: boolean;
}

const Switch: React.FC<SwitchCompProps> = ({
  label,
  checked,
  onChange,
  disabled,
  className = "",
  labelClassName = "",
  inputClassName = "",
  size,
}) => {
  const switchId = useId();

  return (
    <div className={`switch-container ${className}`}>
      <AntdSwitch
        id={switchId}
        className={`switch-input ${inputClassName}`}
        size={size}
        checked={checked}
        onChange={onChange}
        disabled={disabled}
      />
      {label && (
        <label htmlFor={switchId} className={`switch-label ${labelClassName}`}>
          {label}
        </label>
      )}
    </div>
  );
};

export default Switch;
